// CMS 486 and SCIC Order are intentionally omitted. CMS 486 will not
// be supported; SCIC support is tracked separately.
export const ORDER_TYPE_OPTIONS = [
  { value: 'CMS_485', label: 'CMS 485' },
  { value: 'FREQUENCY_ORDER', label: 'Frequency Order' },
  {
    value: 'FREQUENCY_DISCONTINUE_ORDER',
    label: 'Frequency Discontinue Order',
  },
  { value: 'PRN_ORDER', label: 'PRN Order' },
  { value: 'PHYSICIAN_ORDER', label: 'Physician Order' },
  { value: 'POST_HOSPITAL_ORDER', label: 'Post Hospital Order' },
  { value: 'F2F_ENCOUNTER', label: 'F2F Encounter' },
  { value: 'MEDICAID_POC', label: 'Medicaid POC' },
  { value: 'PLAN_OF_CARE_ADDENDUM', label: 'Plan of Care Addendum' },
  { value: 'TP_1', label: 'TP-1' },
  { value: 'TP_2', label: 'TP-2' },
] as const;
